import { mapMutations } from 'vuex';
import { SHOW_DRAWER, SET_MEDIA_LIBRARY_TYPE, SET_PRESELECTED_ITEM_ID } from '@/store/types/mutation-types';

// types of files that can grabbed from the media library
export const TYPE_AUDIO = 'audio';
export const TYPE_DOCUMENT = 'document';
export const TYPE_FILE = 'file';
export const TYPE_IMAGE = 'image';
export const TYPE_VIDEO = 'video';

export const drawerHelperMixin = {
    methods: {
        ...mapMutations({
            showDrawer: SHOW_DRAWER,
            setMediaLibraryType: SET_MEDIA_LIBRARY_TYPE,
            setPreselectedItemId: SET_PRESELECTED_ITEM_ID,
        }),

        // Opens media drawer with the specified media type
        // no type or empty string returns all items
        openMediaDrawer(type = '', id = '') {
            this.setMediaLibraryType(type);
            this.setPreselectedItemId(id);
            this.showDrawer('navigation-tree-media');
        },
    },
};
